import { ProductionFulfillmentApi, useAPIQuery } from "melco-shared-logic";

export const useInputFormatDropdownData = () => {
  return useAPIQuery(
    ProductionFulfillmentApi,
    ["inputFormatsDropdownData"],
    async (api) => {
      const response = await api.productionFulfillmentFormatsGetUserList({
        offset: 0,
        limit: 100,
        sortBy: "display_name.asc",
      });

      return response.list;
    },
    {
      queryOptions: {
        keepPreviousData: true,
      },
    }
  );
};
